// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_lr-0";